import type { GiftCard } from '../GiftCards.types'
import { isGiftCardSingle } from './isGiftCardSingle'

export const getGiftCardTitle = (giftCard: GiftCard) => {
  if (isGiftCardSingle(giftCard)) {
    return giftCard.code
  }

  return `${giftCard.codes[0]} ${giftCard.codes.length > 1 ? ` (+${giftCard.codes.length - 1})` : ''}`
}
